import api from '@/lib/api';

export async function fetchDashboardStats() {
  // The dashboard aggregates data from multiple endpoints.
  // If a dedicated /dashboard/stats endpoint exists, use it;
  // otherwise compose from bookings + reports.
  const [bookingsRes, revenueRes] = await Promise.all([
    api.get('/bookings', { params: { page: 1, limit: 1 } }),
    api.get('/reports/monthly-revenue'),
  ]);
  return {
    bookings: bookingsRes.data,
    revenue: revenueRes.data,
  };
}

export async function fetchRecentBookings(page: number, limit: number) {
  const { data } = await api.get('/bookings', {
    params: { page, limit },
  });
  return data;
}

export async function fetchUpcomingCheckIns() {
  // Fetch bookings checking in today
  const { data } = await api.get('/bookings', {
    params: { status: 'confirmed', page: 1, limit: 50 },
  });
  // Filter client-side for today's check-ins if the API doesn't support it directly
  return data;
}

// ─── Dashboard KPIs ───────────────────────────────────────────────────────────

export interface DashboardKpis {
  revenue: { total: number; currency: string };
  occupancyRate: number;
  adr: number;
  revPar: number;
  totalBookings: number;
  checkedInToday: number;
  checkingOutToday: number;
  arrivalsToday: number;
  revenueTrend: number;
  occupancyTrend: number;
  adrTrend: number;
}

export interface DashboardKpisQuery {
  propertyId: string;
  from: string;
  to: string;
}

export async function fetchDashboardKpis(query: DashboardKpisQuery): Promise<DashboardKpis> {
  const { data } = await api.get<DashboardKpis>('/dashboard/kpis', { params: query });
  return data;
}
